import { Theme } from '@mui/material/styles'
import { DrawerProps } from '@mui/material/Drawer'

// ----------------------------------------------------------------------

export default function Drawer(theme: Theme) {
  return {
    MuiDrawer: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: DrawerProps }) => ({
          ...(ownerState.variant === 'temporary' && {
            // A drawer comes with a backdrop, so it sits in the overlay band.
            '& .MuiDrawer-paper': {
              boxShadow: theme.shadows[16],
            },
          }),
        }),
      },
    },
  }
}
